module.exports = __webpack_public_path__ + "img/20200623-2.7034e973.jpg";